module.exports = __webpack_public_path__ + "img/mf_background.dfd06c04.png";